import React, { useState } from 'react';
import { getToolTipDesc } from '../../../data/utils/getToolTipDesc';
import { getOddDesc } from '../../../common/Odd';
import Img from './Img';
import BottomModal from './BottomModal';
import OverlayContent from './OverlayContent';

export default function BetInfoButton(props) {
    const [toggled, setToggled] = useState(false);

    const tooltips = [];
    props.odds.forEach(o => {
        const desc = getToolTipDesc(o);
        if (desc.length === 0) {
            return null;
        }
        tooltips.push(`${getOddDesc(o)} - ${desc}`);
    });

    if (tooltips.length === 0) {
        return null;
    }

    const toggle = () => setToggled(!toggled);

    return (
        <>
            <div className="c_10_1_1" onClick={toggle}>
                <Img className="c_10_1_1_1" src="info.svg" height="16px" width="16px" />
            </div>
            <BottomModal
                isOpen={toggled}
                onClose={toggle}
                title={props.desc}
                id="xs-bet-info-modal"
            >
                <OverlayContent>
                    {tooltips.map((t, i) =>
                        <span key={i} className="c_23_2_1_1">{t}</span>
                    )}
                </OverlayContent>
            </BottomModal>
        </>
    );
}
